function Services() {
    return (
      <>
        <section className="services">
          <div className="egg image-box"></div>
          <div className="transform brand">
            <h2 className="brands">Transform your brand</h2>
            <p className="text">
              We are a full-service creative agency specilizating in helping
              brands grow fast. Engage your clients through compelling visuals
              that do most of the marketing for you.{" "}
            </p>
            <a href="##" className="learn line">
              LEARN MORE
            </a>
          </div>
          <div className="cup image-box"></div>
          <div className="transform audience">
            <h2 className="right">Stand out to the right audience</h2>
            <p className="text">
              Using a collaborative formula of designers researchers,
              photographers, videographers, and copywriters, we'll build and
              extend your brand in digital places.
            </p>
            <a href="##" className="learn linetwo">
              LEARN MORE
            </a>
          </div>
          <div className="fruit cherry">
            <h2 className="title">Graphic Design</h2>
            <p className="text-two">
              Great design makes you memorable. We deliver artwork that
              underscores your brand message and captures potential client's
              attention.
            </p>
          </div>
          <div className="fruit orange">
            <h2 className="title">Photography</h2>
            <p className="text-two">
              Increase your credibility by gettin the most stunning high quality
              photos that improve your business image.
            </p>
          </div>
        </section>
      </>
    );
}

export default Services;